import PhotoLibraryRounded from '@mui/icons-material/PhotoLibraryRounded';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Container from '../../../layout/Container';
import Gallery from './Gallery';
import AnimatedTypography from '../../core/AnimatedTypography';
import GlassCtaButton from '../../common/GlassCtaButton';

const HomeGallerySection: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box mt={{ xs: 4, md: 6 }}>
            <AnimatedTypography variant='h3' mb={2} color={"text2.primary"} fontWeight={600}>
                {t("appBar.gallery")}
            </AnimatedTypography>
            <Gallery limit={isMobile ? 8 : 12} />
            <Box display="flex" justifyContent="center" mt={3}>
                <GlassCtaButton
                    onClick={() => navigate("/gallery")}
                    leadingIcon={<PhotoLibraryRounded sx={{ fontSize: 28 }} />}
                >
                    {t("gallery.showMore")}
                </GlassCtaButton>
            </Box>
        </Box>
    );
};

export default HomeGallerySection;
